import React, { Component } from 'react';
import autobind from 'autobind-decorator'
import TSubmitButtonForm from "./TSubmitButtonForm";
import * as SaveStatus from '../../constants/SaveStatus'
import * as SaveStatusLabel from '../../constants/SaveStatusLabel'

class TButton extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      status: SaveStatus.READY,
      label: props.label || SaveStatusLabel
    };
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      status: this.makeNextStatus(newProps)
    })
  }

  makeNextStatus(props) {
    const { initialValues, currentValues } = props
    const { status } = this.state

    if (JSON.stringify(initialValues) === JSON.stringify(currentValues)) {
      if (status === SaveStatus.DOING) {
        return SaveStatus.DONE
      } else {
        return SaveStatus.READY
      }
    } else {
      return SaveStatus.CAN_SUBMIT
    }
  }

  @autobind
  handleClick(e){
    const { checkValidation, onClick } = this.props
    const { status } = this.state

    e.preventDefault();

    if (checkValidation) {
      if (!checkValidation()) {
        return
      }
    }

    if(this.isChanged()){
      this.setState({
        status: SaveStatus.DOING
      });

      onClick(() => {}, () => {
        this.setState({
          status: status
        })
      });
    }
  }

  @autobind
  isChanged(){
    return (this.state.status === SaveStatus.CAN_SUBMIT)
  }

  render() {
    const { status, label } = this.state;
    return (
      <TSubmitButtonForm status={status} label={label} onClick={(e) => this.handleClick(e)} />
    )
  }
}

export default TButton;
